const SESSION_KEY = 'tp:table-session';

export interface StoredTableSession {
  battleUuid: string;
  tableProfileId: number;
}

export function saveTableSession(battleUuid: string, tableProfileId: number): void {
  if (!battleUuid || !tableProfileId) return;
  sessionStorage.setItem(
    SESSION_KEY,
    JSON.stringify({ battleUuid, tableProfileId: Math.floor(tableProfileId) })
  );
}

export function readTableSession(): StoredTableSession | null {
  const raw = sessionStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as StoredTableSession;
    const battleUuid = String(parsed.battleUuid || '').trim();
    const tableProfileId = Math.floor(Number(parsed.tableProfileId));
    if (!battleUuid || !Number.isFinite(tableProfileId) || tableProfileId <= 0) return null;
    return { battleUuid, tableProfileId };
  } catch {
    return null;
  }
}

export function clearTableSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
}
